export const enum MemberStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
}
